export const trackEvent = ({ action, label = '', dimensions = '' }) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'interaction',
      eventCategory: 'On-Site Interaction',
      eventAction: action,
      eventLabel: label,
      ...dimensions
    });
  }
};